/* eslint-disable import/prefer-default-export, react/prop-types */
import React, { useEffect } from "react";
import TopLayout from "./TopLayout";
import "../../src/css/global.css";

const ScriptLoader = () => {
  // useEffect(() => {
  //   // Step 1: Load cjm-tracker.js
  //   let cjmTrackerURL = "https://cdn.pnj.io/tracker/prod/cjm-tracker.js";
  //   if (process.env.ENV_PATH === "development") {
  //     cjmTrackerURL = "https://cdn.pnj.io/tracker/cjm-tracker.js";
  //   }
  //   const cjmScript = document.createElement("script");
  //   cjmScript.src = cjmTrackerURL;
  //   cjmScript.async = true;
  //   document.head.appendChild(cjmScript);
  //
  //   // Step 2: Load pnj-bridge.js
  //   const bridgeScript = document.createElement("script");
  //   bridgeScript.src = "https://cdn.pnj.io/tracker/pnj-bridge.js";
  //   bridgeScript.async = true;
  //   document.head.appendChild(bridgeScript);
  //
  //   // Step 3: Add pnjBridgeConfig script
  //   const configScript = document.createElement("script");
  //   configScript.textContent = `
  //     window.pnjBridgeConfig = {
  //       trackingProxyUrl: 'https://www.pnj.com.vn/tracking-proxy.html',
  //       localStorageKey: 'voc_visitor_id',
  //       requiredParams: ['soNum', 'phoneNum'],
  //       eventNameForProxy: 'voc_page_view',
  //       debug: false,
  //       showLoadingOverlay: true
  //     };
  //   `;
  //   document.head.appendChild(configScript);
  //
  //   // Step 4: Execute custom script after both tracker and bridge scripts load
  //   let scriptsLoaded = 0;
  //   const onScriptLoad = () => {
  //     scriptsLoaded += 1;
  //     if (scriptsLoaded === 2) {
  //       // Initialize CJMTracker
  //       if (typeof window.CJMTracker !== "undefined") {
  //         window.CJMTracker("init", {
  //           trackingId: "CJM-5kHGTcgtjk",
  //           apiKey: process.env.GATSBY_CJM_KEY,
  //           trackEndpoint:
  //             process.env.GATSBY_END_POINT + "/ecom-frontend/v1/track",
  //           campaignsEndpoint:
  //             process.env.GATSBY_END_POINT + "/ecom-frontend/v1/campaigns",
  //           debug: false,
  //         });
  //         window.CJMTracker.initialized = true;
  //         console.log("CJMTracker initialized");
  //       } else {
  //         console.error("CJMTracker not available for initialization");
  //       }
  //
  //       // Create custom script
  //       const customScript = document.createElement("script");
  //       customScript.textContent = `
  //         (function() {
  //           console.log('Custom script running');
  //           if (typeof pnjBridge === 'undefined') {
  //             console.error('pnjBridge is not defined. Ensure the library is loaded.');
  //             return;
  //           }
  //
  //           // Manually save visitor_id from URL
  //           const urlParams = new URLSearchParams(window.location.search);
  //           const visitorIdFromUrl = urlParams.get('visitor_id');
  //           if (visitorIdFromUrl) {
  //             pnjBridge.setVisitorId(visitorIdFromUrl);
  //             console.log('Manually saved visitor_id from URL:', visitorIdFromUrl);
  //           }
  //
  //           pnjBridge.init({
  //             debug: false
  //           });
  //
  //           pnjBridge.createDebugPanel();
  //           pnjBridge.attachVisitorIdToForm('#rating-form');
  //
  //           const params = pnjBridge.getUrlParams();
  //           const soNum = params.soNum || 'N/A';
  //           const orderNumber = document.getElementById('order-number');
  //           if (orderNumber) {
  //             orderNumber.textContent = soNum;
  //           }
  //
  //           const ratingInputs = document.querySelectorAll('input[name="rating"]');
  //           ratingInputs.forEach(input => {
  //             input.addEventListener('change', function() {
  //               pnjBridge.trackEvent('voc_rating_select', {
  //                 rating: this.value
  //               });
  //             });
  //           });
  //
  //           let commentTimeout;
  //           const commentInput = document.getElementById('comment');
  //           if (commentInput) {
  //             commentInput.addEventListener('input', function() {
  //               clearTimeout(commentTimeout);
  //               commentTimeout = setTimeout(() => {
  //                 pnjBridge.trackEvent('voc_comment_input', {
  //                   comment_length: this.value.length,
  //                   has_comment: this.value.length > 0
  //                 });
  //               }, 2000);
  //             });
  //           }
  //
  //           const ratingForm = document.getElementById('rating-form');
  //           if (ratingForm) {
  //             ratingForm.addEventListener('submit', function(e) {
  //               e.preventDefault();
  //               const formData = new FormData(this);
  //               const rating = formData.get('rating');
  //               const comment = formData.get('comment');
  //               const phone = formData.get('phone');
  //               const visitorId = pnjBridge.getVisitorId();
  //
  //               if (!rating) {
  //                 alert('Vui lòng chọn số sao đánh giá!');
  //                 return;
  //               }
  //
  //               pnjBridge.trackEvent('voc_form_submit', {
  //                 rating: rating,
  //                 comment: comment,
  //                 phone: phone,
  //                 comment_length: comment ? comment.length : 0,
  //                 has_comment: comment && comment.length > 0
  //               });
  //
  //               alert('Cảm ơn bạn đã gửi đánh giá ' + rating + ' sao!\\n\\n' +
  //                     'Visitor ID: ' + (visitorId || 'Không có') + '\\n' +
  //                     'Đơn hàng: ' + soNum + '\\n' +
  //                     'Phone: ' + (phone || 'Không cung cấp') + '\\n' +
  //                     'Comment: ' + (comment || 'Không có nhận xét'));
  //
  //               pnjBridge.redirectWithVisitorId('thank-you?soNum=' + soNum + '&phoneNum=' + (params.phoneNum || '') + '&rating=' + rating);
  //             });
  //           }
  //
  //           window.addEventListener('beforeunload', function() {
  //             const visitorId = pnjBridge.getVisitorId();
  //             if (navigator.sendBeacon && visitorId) {
  //               const data = {
  //                 event_name: 'voc_page_exit',
  //                 data: {
  //                   visitorId: visitorId,
  //                   page: window.location.href,
  //                   time_on_page: Math.floor((Date.now() - window.performance.timing.navigationStart) / 1000)
  //                 }
  //               };
  //               navigator.sendBeacon('https://edge-api.stage.pnj.io/ecom-frontend/v1/track', JSON.stringify(data));
  //             }
  //           });
  //         })();
  //       `;
  //
  //       // Append the custom script with a safety check
  //       const appendScript = () => {
  //         if (document.body) {
  //           console.log("Appending custom script to document.body");
  //           document.body.appendChild(customScript);
  //         } else {
  //           console.warn("document.body is null, retrying...");
  //           requestAnimationFrame(appendScript);
  //         }
  //       };
  //
  //       // Initial attempt to append
  //       appendScript();
  //     }
  //   };
  //
  //   // Attach onload handlers for tracker and bridge scripts
  //   cjmScript.onload = onScriptLoad;
  //   bridgeScript.onload = onScriptLoad;
  //
  //   // Handle errors if scripts fail to load
  //   cjmScript.onerror = () => {
  //     console.error("Failed to load cjm-tracker.js");
  //   };
  //   bridgeScript.onerror = () => {
  //     console.error("Failed to load pnj-bridge.js");
  //   };
  //
  //   // Cleanup on component unmount
  //   return () => {
  //     if (document.head.contains(cjmScript)) {
  //       document.head.removeChild(cjmScript);
  //     }
  //     if (document.head.contains(bridgeScript)) {
  //       document.head.removeChild(bridgeScript);
  //     }
  //     if (document.head.contains(configScript)) {
  //       document.head.removeChild(configScript);
  //     }
  //   };
  // }, []);

  return null;
};

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <TopLayout>{element}</TopLayout>
      <ScriptLoader />
    </>
  );
};
